import { Component, OnInit } from '@angular/core';
import { BonusqrService } from 'src/app/shared/servicio/bonusqr/bonusqr.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-bonus-qr-referrals',
  templateUrl: './bonus-qr-referrals.component.html',
  styleUrls: ['./bonus-qr-referrals.component.css'],
})
export class BonusQrReferralsComponent implements OnInit {
  loading = false;
  referrals: any[] = [];
  count = 0;
  page = 1;
  hasNext = false;
  hasPrevious = false;

  isAdmin = localStorage.getItem('type') === '3';

  constructor(private _bonusqr: BonusqrService, public _helper: HelpersService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this._bonusqr.getGlobalReferrals(this.page).subscribe(
      (data: any) => {
        this.referrals = data.results || [];
        this.count = data.count || 0;
        this.hasNext = !!data.next;
        this.hasPrevious = !!data.previous;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this._helper.modalError('No se pudo cargar el listado de referidos');
      }
    );
  }

  nextPage(): void {
    if (!this.hasNext) {
      return;
    }
    this.page++;
    this.load();
  }

  previousPage(): void {
    if (!this.hasPrevious || this.page <= 1) {
      return;
    }
    this.page--;
    this.load();
  }
}
